<app-layout>
  @if (provider$ | async; as provider) {
    <app-side-nav variant="secondary">
      <bit-nav-logo
        [openIcon]="logo$ | async"
        route="."
        [label]="'providerPortal' | i18n"
      ></bit-nav-logo>
      <bit-nav-item
        icon="bwi-provider"
        [text]="clientsTranslationKey$ | async | i18n"
        route="clients"
      >
        @if (!provider.enabled) {
          <bit-icon
            name="bwi-exclamation-triangle"
            slot="end"
            class="tw-text-danger"
            title="{{ 'providerIsDisabled' | i18n }}"
          />
        }
      </bit-nav-item>
      @if (showManageTab(provider)) {
        <bit-nav-group icon="bwi-sliders" [text]="'manage' | i18n" route="manage">
          <bit-nav-item [text]="'members' | i18n" route="manage/members"></bit-nav-item>
          @if (provider.useEvents) {
            <bit-nav-item [text]="'eventLogs' | i18n" route="manage/events"></bit-nav-item>
          }
        </bit-nav-group>
      }
      @if (canAccessBilling$ | async) {
        <bit-nav-group icon="bwi-billing" [text]="'billing' | i18n" route="billing">
          <bit-nav-item [text]="'subscription' | i18n" route="billing/subscription"></bit-nav-item>
          <bit-nav-item
            [text]="'paymentDetails' | i18n"
            route="billing/payment-details"
          ></bit-nav-item>
          <bit-nav-item [text]="'billingHistory' | i18n" route="billing/history"></bit-nav-item>
        </bit-nav-group>
      }
      @if (showSettingsTab(provider)) {
        <bit-nav-item icon="bwi-cog" [text]="'settings' | i18n" route="settings"></bit-nav-item>
      }
    </app-side-nav>
  }

  @if (subscriber$ | async; as subscriber) {
    <app-tax-id-warning
      [subscriber]="subscriber"
      [getWarning$]="getTaxIdWarning$"
      (billingAddressUpdated)="refreshTaxIdWarning()"
    >
    </app-tax-id-warning>
  }

  <router-outlet></router-outlet>
</app-layout>
